/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AiEmailCampaignBuilder from './icon-ai-email-campaign-builder.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <AiEmailCampaignBuilder {...validProps} />;
}
SvgComponent.iconName = 'aiEmailCampaignBuilder';

export const AiEmailCampaignBuilderIcon = svgIconWrapper(SvgComponent);
